module.exports = __webpack_public_path__ + "static/media/caixa.99cd4e0f.png";